module.exports = __webpack_public_path__ + "media/img/advice/icon--man-61b020ac4506a359d4cc5e65a124909e.png";